export default __webpack_public_path__ + "static/media/icon_slide_arrow_20.7a3d1c6c.svg";